/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCloudStorm = createReactComponent("outline", "cloud-storm", "IconCloudStorm", [["path", { "d": "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1", "key": "svg-0" }], ["path", { "d": "M13 14l-2 4l3 0l-2 4", "key": "svg-1" }]]);

export { IconCloudStorm as default };
//# sourceMappingURL=IconCloudStorm.mjs.map
